<template>
  <div>
    <b-col md="12">
      <card class="data-card">
        <b-row no-gutters>
          <b-col no-gutters>
            <div class="d-flex align-center justify-content-between mb-4 w-100">
              <h2 class="">
                فلیتر واریز های بانکی
              </h2>

              <base-button
                :loading="updateLoading"
                @click="refresh"
              >
                به روز رسانی
              </base-button>
            </div>
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col no-gutters>
            <BaseDatePicker />
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col
            no-gutters
            class="mt-5"
          >
            <b-button
              size="sm"
              class="p-2 pl-4 pr-4"
              type="submit"
              variant="primary"
            >اعمال فیلتر
            </b-button>
          </b-col>
        </b-row>
      </card>
      <card
        class="data-card mt-4 mr-3 ml-3"
        :show-footer-line="true"
      >
        <b-row no-gutters>
          <b-col no-gutters>
            <h1 class="card-header text-right">واریز های بانکی</h1>
          </b-col>
        </b-row>
        <b-skeleton-table
          v-if="loading"
          :rows="10"
          :columns="4"
          :table-props="{ bordered: true, striped: true }"
        >
        </b-skeleton-table>
        <b-row v-if="!loading">
          <b-col md="12">
            <!-- <h1 class="section-header">کیف های پول</h1> -->
            <b-card
              class="wallets-table"
              no-body
            >
              <b-table
                emptyText="تاریخچه ای یافت نشد"
                :items="histories"
                :fields="fields"
                show-empty
                responsive
                small
              >

                <template #cell(user)="row">
                  <b-button
                    v-if="row.item.user"
                    variant="primary"
                    size="sm"
                    @click="$router.push('/user-profile/'+row.item.user);"
                  >
                    نمایش جزییات کاربر
                  </b-button>
                </template>

                <template #cell(shebaNumber)="row">
                  {{ row.item.shebaNumber }}
                </template>

                <template #cell(amount)="row">
                  {{ addCommas(row.item.amount) }}
                </template>

                <!--              <template #cell(identifier)="row">-->
                <!--                {{ row.item.identifier }}-->
                <!--              </template>-->

                <!--              <template #cell(amount)="row">-->
                <!--                {{ addCommas(row.item.amount) }}-->
                <!--              </template>-->

                <!--              <template #cell(requestDate)="row">-->
                <!--                {{row.item.requestDate}}-->
                <!--              </template>-->

                <template #cell(status)="row">
                  <b-button
                    size="sm"
                    variant="outline-primary"
                  >
                    {{ row.item.status.label }}
                  </b-button>
                </template>

                <!--              <template #cell(description)="row">-->
                <!--               {{row.items.description}}-->
                <!--              </template>-->

                <template #cell(actions)="row">
                  <template v-if="adminsAccessOnly">

                    <b-button
                      @click="showModalApprove(row.item)"
                      class="ml-2"
                      v-if="row.item.status.value === 'Pending'"
                      size="sm"
                      variant="primary"
                    >
                      تایید کردن
                    </b-button>

                    <b-button
                      @click="showModalReject(row.item)"
                      v-if="row.item.status.value === 'Pending'"
                      size="sm"
                      variant="danger"
                    >
                      رد کردن
                    </b-button>
                  </template>
                </template>
              </b-table>
            </b-card>
            <div class="paginationNav">
              <b-row>
                <b-col class="mt-4">
                  <BasePagination
                    :showNext="showNext"
                    :showPrev="currentPage !== 0"
                    @onClick="handlePaginationClick"
                  />
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </card>
    </b-col>

    <b-modal
      hide-footer
      v-model="rejectedObject.modal"
      title="رد کردن واریز بانکی"
    >
      <b-textarea
        placeholder="توضیحات"
        v-model="rejectedObject.description"
      />
      <div class="d-flex align-items-center justify-content-between mt-4">
        <b-button @click="rejectedObject.modal = false">
          بستن
        </b-button>

        <base-button
          @click="rejectItem"
          :loading="rejectedObject.loading"
          :disabled="!rejectedObject.description"
          variant="primary"
        >
          تایید
        </base-button>
      </div>
    </b-modal>
    <b-modal
      hide-footer
      v-model="approvedObject.modal"
      title="تایید کردن واریز بانکی"
    >
      <div>
        <b-input
          placeholder="ایدی کاربر را وارد کنید"
          v-model="approvedObject.accountId"
        />
      </div>
      <div class="d-flex align-items-center justify-content-between mt-4">

        <b-button @click="approvedObject.modal = false">
          بستن
        </b-button>

        <base-button
          :disabled="!approvedObject.accountId"
          @click="approveItem"
          :loading="approvedObject.loading"
          variant="primary"
        >
          تایید
        </base-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import CryptoIcons from "@/components/CryptoIcons";
import BasePagination from "@/components/BasePagination.vue";
import filterAndPaginate from "@/mixins/filterAndPaginate";
import BaseDatePicker from "@/components/Inputs/BaseDatePicker";
import dateHelper from "@/utils/DateHelper";
import {
  fetchDustingReportDetail,
  fetchDustingReports,
} from "@/httpservices/Dusting";
import { addCommas } from "@persian-tools/persian-tools";
import http from "@/httpservices/HttpService";
import moment from "jalali-moment";
import Swal from "sweetalert2";
import store from "@/store";

export default {
  mixins: [filterAndPaginate],

  components: {
    CryptoIcons,
    BaseDatePicker,
    BasePagination,
  },

  data() {
    return {
      fields: [
        {
          key: "user",
          label: "کاربر",
        },
        {
          key: "shebaNumber",
          label: "شماره شبا",
        },
        {
          key: "identifier",
          label: "شناسه تراکنش",
        },
        {
          key: "amount",
          label: "مبلغ",
        },
        {
          key: "requestDate",
          label: "تاریخ",
        },
        {
          key: "status",
          label: "وضعیت",
        },
        { key: "actions", label: "فعالیت" },
        {
          key: "description",
          label: "توضیحات",
        },
      ],
      histories: [],
      loading: false,
      currentPage: 0,
      filterData: {
        fromDate: null,
        toDate: null,
        pageSize: 25,
      },
      showMore: {
        modal: false,
        loading: true,
        data: [],
      },
      rejectedObject: {
        loading: false,
        modal: false,
        description: "",
        id: "",
      },
      approvedObject: {
        loading: false,
        modal: false,
        id: "",
        accountId: "",
      },
      updateLoading: false,
    };
  },

  computed: {
    adminsAccessOnly() {
      return Boolean(
        store.getters["isSuperAdmin"] || store.getters["isApprovingManager"]
      );
    },
  },

  mounted() {
    this.getHistory();
  },

  methods: {
    addCommas,
    async refresh() {
      const confirm = window.confirm("آیا مطمئن هستید ؟ ");
      if (!confirm) return;
      this.updateLoading = true;
      try {
        await http.post("Configs/manualFiatDepositUrgentRequest");
        alert("با موفقیت انجام شد.");
      } catch (e) {
        console.log(e);
      }
      this.updateLoading = false;
    },
    async getHistory() {
      this.loading = true;
      const status = {
        pending: "در حال بررسی",
        approved: "تایید شده",
        rejected: "رد شده",
      };
      try {
        const { data } = await http.get(
          `/AdminReports/manual-fiat-deposit/page/0/`,
          {
            PageSize: 1000,
          }
        );
        this.histories = data.data.map((item) => {
          return {
            id: item.id,
            user: item.accountId,
            accountId: item.accountId,
            shebaNumber: item.shebaNumber,
            identifier: item.identifier,
            amount: item.amount,
            description: item.description,
            created: item.created,
            requestDate: moment
              .utc(item.requestDate)
              .locale("fa")
              .format("jYYYY-jMM-jDD HH:mm"),
            status: {
              value: item.status,
              label: status[item.status.toLowerCase()],
            },
          };
        });
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },

    async showDetails(orderId) {
      this.showMore = {
        ...this.showMore,
        modal: true,
        loading: true,
        data: [],
      };
      this.$bvModal.show("show-more");
      try {
        const res = (await fetchDustingReportDetail(orderId)).data || [];
        //result equal to :
        // amount:"10.0"
        // asset:"TRX"
        // date:"2022-12-07T13:53:50.79838"
        // id:"49160697-c828-4c4e-9c2b-aafc183d0015"
        // orderId:"209e67ee-9232-40ed-8130-cfde775a5b08"
        // toAssetAmount:"15664.3200000"
        // unitPriceInUsdt:"0.0522144"
        this.showMore.data = res.map((item) => {
          return {
            fromAssetImg: `/img/coins/svg/${item.asset.toLowerCase()}_.svg`,
            fromAsset: item.asset,
            fromAssetAmount: item.amount,
            toAssetImg: `/img/coins/svg/irt_.svg`,
            toAsset: "IRT",
            toAssetAmount:
              item.toAssetAmount > 1
                ? addCommas(Number(item.toAssetAmount).toFixed(0))
                : item.toAssetAmount,
          };
        });
      } catch (e) {
        console.log(e);
      }
      this.showMore.loading = false;
    },

    showModalReject(item) {
      this.rejectedObject = {
        ...this.rejectedObject,
        loading: false,
        modal: true,
        description: "",
        id: item.id,
      };
    },

    async rejectItem() {
      this.rejectedObject.loading = true;
      try {
        await http.post("ManualFiatDeposit/reject", {
          depositId: this.rejectedObject.id,
          description: this.rejectedObject.description,
        });
        this.rejectedObject.modal = false;
        await Swal.fire({
          title: "انجام شد.",
          icon: "success",
          confirmButtonText: "باشه",
        });
        await this.getHistory();
      } catch (e) {
        console.log(e);
      }
      this.rejectedObject.loading = false;
    },

    showModalApprove(item) {
      this.approvedObject = {
        ...this.approvedObject,
        loading: false,
        modal: true,
        description: "",
        id: item.id,
        accountId: "",
      };
    },

    async approveItem() {
      this.approvedObject.loading = true;
      try {
        await http.post("ManualFiatDeposit/approve", {
          depositId: this.approvedObject.id,
          accountId: this.approvedObject.accountId,
        });
        await Swal.fire({
          title: "انجام شد.",
          icon: "success",
          confirmButtonText: "باشه",
        });
        await this.getHistory();
      } catch (e) {
        console.log(e);
      }
      this.approvedObject.loading = false;
      this.approvedObject.modal = false;
    },
  },
};
</script>

